/// JTF3-added-AB-22-05-12

'use strict'

jQuery(document).ready(function($) {
	console.log('FANCY SEARCH V1.0.10')
	
	$('.searchajax__trigger').each(function(){
		let target = $(this).attr('data-site');
		let term = $(this).attr('data-term');
		let pagination = $(this).attr('data-pagination')
		var self = $(this)
		
		$.ajax({
			url: 'wp-content/themes/JTF/functions/search_ajax.php',
			//context: document.body
			type: 'GET',
			data: {
				search: encodeURIComponent(term),
				url: 'https://' + target,
				api: 'count',
				pagination: pagination
			}
		}).success(function( response ) {
			const results = JSON.parse(response)
			
			self.find('span').html('(' + results + ')')
			console.log(results)
		});
	})
	
	$('.searchajax__pagination a').click(function(){
		let direction = $(this).attr('data-direction');
		
		if ( direction == 'plus' ) {
			$('.searchajax__pagination')
		} else {
		
		}
	})
	
	function render_results( json, term, target ) {
		const results = JSON.parse( json )
		
		console.log(results)
		
		var all_elements = [];
		
		for ( let x = 0; x < results.length; x++ ) {
			const col = $('<div/>',
				{
					'class': 'col-md-6 col-12'
				}
			)
			
			const section = $('<section/>',
				{
					'class': 'section'
				}
			)
			
			const h2 = $('<h2/>',
				{
					'class': ''
				}
			)
			
			const p = $('<p/>',
				{
					'class': ''
				}
			)
			
			const anchor = $('<a/>',
				{
					'class': 'btn btn-default blue-btn',
					'href': results[x].url
				}
			)
			
			
			let title = results[x].title
			let regEx = new RegExp(term, "ig");
			let excerpt = results[x].excerpt;
		
			if ( $.isArray(excerpt) ){
				excerpt = excerpt[0]
			}
			
			title = title.replace(regEx, '<span class="search-highlight">' + term + '</span>')
			if ( excerpt != '' ) {
				excerpt = excerpt.replace(regEx, '<span class="search-highlight">' + term + '</span>')
			} else {
				excerpt = 'no excerpt supplied'
			}
			
			
			anchor.text( 'Read More' );
			h2.html( title );
			p.html( excerpt )
			section.append( h2 )
			section.append( p )
			section.append( anchor )
			col.append( section )
			
			all_elements.push(col);
			
		}
		const pagination_container = $('<div/>',
			{
				'class': 'col-12 searchajax__pagination'
			}
		)
		
		const pagination_next = $('<a/>',
			{
				'class': 'searchajax__pagination--next btn btn-default blue-btn',
				'data-direction': 'plus',
				'href': '#'
			}
		)
		
		pagination_next.text('Next')
		
		const pagination_prev = $('<a/>',
			{
				'class': 'searchajax__pagination--prev btn btn-default blue-btn',
				'data-direction': 'minus',
				'href': '#'
			}
		)
		
		pagination_prev.text('Prev')
		
		pagination_container.append(pagination_prev)
		pagination_container.append(pagination_next)
		all_elements.push(pagination_container);
		
		$('.search__results').html(all_elements);
	}
	
	
	$('.searchajax__trigger').on('click', function(e) {
		e.preventDefault();
		let target = $(this).attr('data-site');
		let term = $(this).attr('data-term');
		
		$('.searchajax__trigger--active').removeClass('searchajax__trigger--active');
		$(this).addClass('searchajax__trigger--active')

		$.ajax({
			url: 'wp-content/themes/JTF/functions/search_ajax.php',
			//context: document.body
			type: 'GET',
			data: {
				search: encodeURIComponent(term),
				url: 'https://' + target,
				api: 'search'
			}
		}).success(function( response ) {
			render_results(response, term, target)
		});
		
	})
});
